import componentFn from '../../styles/objects/component'
import modalFn from '../../styles/objects/modal'

export default ({
  colors,
  spacings,
  images,
  fontFamilies,
  fontWeights,
  fontSizes,
  textTransforms
}) => {
  const component = componentFn({
    colors,
    spacings,
    images,
    fontFamilies,
    fontWeights,
    fontSizes,
    textTransforms
  })
  const modal = modalFn({ colors, spacings, images, fontWeights })

  const styles = {
    token: {
      width: '10.6rem',
      height: '4.9rem',
      marginTop: spacings.x4,
      marginRight: 'auto',
      marginLeft: 'auto',

      backgroundImage: images.rsaToken,
      backgroundRepeat: 'no-repeat'
    },
    closeBtn: {
      position: 'fixed',
      zIndex: '100',
      top: '0',
      right: '0',

      width: spacings.x4,
      height: spacings.x4,
      marginTop: spacings.x4,
      marginRight: spacings.x4,

      cursor: 'pointer',

      borderRadius: '100%',
      backgroundColor: colors.button.bg.sella,
      backgroundImage: images.closeIconSella,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    bg: {
      backgroundColor: colors.auth.sella.bg,
      zIndex: 100,
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0.97
    },
    content: {
      ...modal.content,

      backgroundColor: 'transparent',
      maxWidth: '400px',
      textAlign: 'center',

      '.o-component': {
        marginBottom: '0'
      }
    },
    title: {
      margin: '0',

      textAlign: 'center',

      display: 'inline-block',

      marginLeft: `-${spacings.x3}`,
      paddingLeft: spacings.x6,
      paddingBottom: spacings.x2,
      paddingTop: spacings.x2,

      whiteSpace: 'nowrap',

      color: colors.auth.sella.title,
      backgroundImage: images.sellaItLogo,
      backgroundPositionY: 'center',
      backgroundRepeat: 'no-repeat'
    },
    subtitle: {
      fontSize: '1.1rem',
      fontWeight: fontWeights.subtitle.sella,

      marginTop: spacings.x4,

      color: colors.auth.sella.title
    },
    message: {
      margin: '0',

      textAlign: 'center'
    },
    form: {
      width: 'auto',
      marginRight: 'auto',
      marginLeft: 'auto'
    },
    field: {
      marginBottom: spacings.default
    },

    'label--auth': {
      color: colors.label.sellaAuth,
      marginTop: `-${spacings.default}`
    },

    'label--required': {
      color: colors.common.utility.error.default
    },
    input: {
      ...component.input,

      border: `1px solid ${colors.input.border.sella}`,
      borderRadius: '4px',

      ':active': {
        borderBottom: `1px solid ${colors.input.border.sella}`,
        outline: 'none'
      },

      ':focus': {
        borderBottom: `1px solid ${colors.input.border.sella}`,
        outline: 'none'
      }
    },
    off: {
      color: colors.auth.sella.off
    },
    link: {
      textDecoration: 'none',

      color: colors.auth.sella.link.default,
      ':hover': {
        color: colors.auth.sella.link.hover
      }
    },
    'recover--success': {
      display: 'block',

      margin: '0 auto',
      paddingBottom: '85px'
    },
    links: {
      fontSize: '12px',

      display: 'inline-block',

      marginTop: '1rem'
    }
  }

  return { ...component, ...modal, ...styles }
}



// WEBPACK FOOTER //
// ./components/authmodal/styles.js